var LinkButton = function (_a) {
    var children = _a.children, className = _a.className, onClick = _a.onClick, target = _a.target, rel = _a.rel, _b = _a.disabled, disabled = _b === void 0 ? false : _b, _c = _a.href, href = _c === void 0 ? '#' : _c, _d = _a.type, type = _d === void 0 ? 'link' : _d, download = _a.download, ariaLabel = _a.ariaLabel;
    var handleClick = function (event) {
        if (disabled || href === '#') {
            event.preventDefault();
        }
        if (disabled) {
            return;
        }
        onClick === null || onClick === void 0 ? void 0 : onClick(event);
    };
    var baseClass = "c-link-button c-link-button--".concat(type);
    var combinedClassName = className ? "".concat(baseClass, " ").concat(className) : baseClass;
    return (
    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    <a href={disabled ? undefined : href} className={combinedClassName} onClick={handleClick} target={target} rel={rel} aria-disabled={disabled} aria-label={ariaLabel} download={download} tabIndex={disabled ? -1 : 0}>
      {children}
    </a>);
};
export default LinkButton;
